import { useState } from 'react';
import { useAuth } from './AuthProvider';

export default function LoginPage() {
  const { loginWithSSO, loginWithCredentials, error, isLoading } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email && password) loginWithCredentials(email, password);
  };

  return (
    <div className="min-h-screen bg-[var(--surface-page)] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-[var(--surface-primary)] rounded-2xl shadow-lg border border-[var(--border-primary)] p-8">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img src="/cgiar-logo.svg" alt="CGIAR" className="h-12" />
          </div>

          {/* Title */}
          <h1 className="text-2xl font-bold text-center text-[var(--text-primary)] mb-1">
            Zero Draft Reports
          </h1>
          <p className="text-sm text-center text-[var(--text-secondary)] mb-8">
            Enter your credentials to access your account
          </p>

          {/* Error */}
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
              {error}
            </div>
          )}

          {/* Email/Password Form */}
          <form onSubmit={handleSubmit} className="space-y-3 mb-5">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg border border-[var(--border-primary)] bg-[var(--surface-primary)] text-[var(--text-primary)] text-sm placeholder:text-[var(--text-tertiary)] focus:outline-none focus:ring-2 focus:ring-cgiar-green/40 focus:border-cgiar-green"
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2.5 rounded-lg border border-[var(--border-primary)] bg-[var(--surface-primary)] text-[var(--text-primary)] text-sm placeholder:text-[var(--text-tertiary)] focus:outline-none focus:ring-2 focus:ring-cgiar-green/40 focus:border-cgiar-green"
            />
            <button
              type="submit"
              disabled={isLoading || !email || !password}
              className="w-full py-2.5 px-4 rounded-lg bg-cgiar-green hover:bg-cgiar-green-dark text-white font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>

          {/* Divider */}
          <div className="flex items-center gap-3 mb-5">
            <div className="flex-1 h-px bg-[var(--border-primary)]" />
            <span className="text-xs text-[var(--text-tertiary)]">or</span>
            <div className="flex-1 h-px bg-[var(--border-primary)]" />
          </div>

          {/* SSO Button */}
          <button
            onClick={loginWithSSO}
            disabled={isLoading}
            className="w-full py-2.5 px-4 rounded-lg border border-[var(--border-primary)] bg-[var(--surface-primary)] hover:bg-[var(--surface-secondary)] text-[var(--text-primary)] font-medium transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Sign in with CGIAR SSO
          </button>

          <p className="text-center text-xs text-[var(--text-tertiary)] mt-5 leading-relaxed">
            Use SSO for CGIAR accounts.<br />
            Email login is for invited external users.
          </p>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-[var(--text-tertiary)] mt-6">
          CGIAR Portfolio Performance Team &middot; Office of the Chief Scientist
        </p>
      </div>
    </div>
  );
}
